import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

export default function ReturnPolicy({ onClose }) {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // trigger animation on mount
    setTimeout(() => setIsAnimating(true), 10);
  }, []);

  const handleClose = () => {
    setIsAnimating(false);
    setTimeout(() => {
      onClose();
    }, 300); // match duration
  };

  return (
    <>
      {/* BACKDROP */}
      <div
        className={`fixed inset-0 bg-black z-50 transition-opacity duration-300 ease-out ${
          isAnimating ? "opacity-50" : "opacity-0"
        }`}
        onClick={handleClose}
      />

      {/* MODAL WRAPPER */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
        
        {/* MODAL BOX */}
        <div
          className={`bg-white w-full max-w-md rounded-lg shadow-2xl pointer-events-auto transform transition-all duration-300 ease-out ${
            isAnimating
              ? "scale-100 opacity-100 translate-y-0"
              : "scale-90 opacity-0 translate-y-4"
          }`}
        >
          {/* HEADER */}
          <div className="p-6 border-b flex justify-between items-center">
            <h2 className="text-lg font-medium">Return Policy</h2>
            <button onClick={handleClose} className="hover:opacity-60 transition">
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* CONTENT */}
          <div
            className="p-6 transition-all duration-300"
            style={{
              opacity: isAnimating ? 1 : 0,
              transform: isAnimating ? "translateY(0)" : "translateY(10px)",
              transitionDelay: "100ms",
            }}
          >
            <p className="text-gray-700 text-sm leading-6">
              All purchases made on zipNzip are final. This product is not
              returnable, refundable, or exchangeable under any circumstances.
              By placing an order, you agree to this policy. This condition is
              strictly non-negotiable.
            </p>

            <button
              onClick={handleClose}
              className="mt-6 w-full bg-black text-white py-2 rounded text-sm hover:bg-gray-800 transition"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
}